import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Skeleton } from 'primeng/skeleton';

@Component({
  selector: 'app-card-value-pair',
  imports: [Skeleton, CommonModule],
  templateUrl: './card-value-pair.component.html',
  styleUrl: './card-value-pair.component.css',
  standalone: true,
})
export class CardValuePairComponent {
  @Input({ required: true }) isLoading: boolean = false;
  @Input({ required: true }) title!: string;
  @Input({ required: true }) icon!: string;
  @Input({ required: true }) value!: string;
  @Input({ required: true }) borderBottomColor!: string;
  @Input({ required: false }) detailIcon?: string;
  @Input({ required: true }) detailValue!: string;
  @Input() tooltip1: string = '';
  @Input() tooltip2: string = '';
}
